<template>
  <div class="page">
    <div autoplay="autoplay" class="page-container">
      <Player
        v-if="!isShowCover"
        class="video B1 special-video"
        @onStartPlay="onStartPlay"
        ref="videoBox"
      >
        <div class="anim-box" @click.stop="controlVideo">
          <img
            src="../../static/ic_play_grey.png"
            class="static-ico"
            v-show="!isPlaying"
          />
          <lottie
            :options="defaultOptions"
            :height="120"
            :width="300"
            v-on:animCreated="handleAnimation"
          />
        </div>
      </Player>
      <VideoMask v-if="isMaskShowFix" :style="[videoHeightStyle]" />
      <div :style="videoHeightStyle" />
      <div
        class="cover B1"
        v-if="isShowCover"
        :style="[videoHeightStyle]"
        style="z-index: 10002"
      >
        <img
          class="imgDefault"
          :src="
            resp && resp.detail && resp.detail.detail.coverImagUrl
              ? resp.detail.detail.coverImagUrl
              : ''
          "
          style="width: 100%;'object-fit': 'cover'"
          :style="[videoHeightStyle]"
          alt=""
        />
        <img
          src="../../static/ic_play_grey.png"
          class="btnPlay"
          @click="playCourseVideo(resp.detail.courses.page.list[0])"
          alt=""
        />
      </div>
      <template v-if="getTodayTip">
        <div class="S8 T1 marginL30 jrgxTitle">今日更新</div>
        <div
          class="videoToday"
          @click="playCourseVideo(getTodayTip)"
          :class="getTodayTip.videoIdenftity === currentVideo ? 'C5' : 'T1'"
        >
          【{{ dayjs(getTodayTip.updateTime).format('MM-DD') || '' }}】
          {{ getTodayTip.title || '' }}
          <img src="../../static/ic_play_grey.png" />
        </div>
      </template>
      <van-sticky :offset-top="navOffest">
        <NavItem :items="navItems" @onItemClick="onItemClick" />
      </van-sticky>
      <swiper
        :options="swiperOption"
        class="my-swiper"
        ref="mySwiper"
        @slideChange="slideChange"
      >
        <swiper-slide>
          <CourseVideoDetail
            @updateSwiper="updateSwiper"
            @playCourseVideo="playCourseVideo"
          />
        </swiper-slide>
        <swiper-slide>
          <Comment
            @updateSwiper="updateSwiper"
            videoType="shrink"
            :showPupInput="!showCommentDetail && !!currentIndex"
            :hasPermission="isAvailable"
            @onReplyEvent="onReplyEvent"
            @onShowAllEvent="onShowAllEvent"
            :commentsInfo="commentsInfo"
          />
        </swiper-slide>
      </swiper>
      <PayBanner
        :subscribeStatus="
          resp &&
            resp.detail &&
            resp.detail.detail &&
            resp.detail.detail.subscribeStatus
        "
        videoType="shrink"
        v-show="!(isAvailable && !!currentIndex)"
      />
    </div>

    <div
      class="comment-container B1"
      :style="[commentStyle]"
      v-if="showCommentDetail"
      @touchmove.stop
    >
      <CommentDetail
        :commentsInfo="commentsInfo"
        :comment="currComment"
        :isPermission="isAvailable"
        :isShowAll="isShowAll"
        @onCloseEvent="onCloseEvent"
      />
    </div>

    <div
      class="onlineservice"
      :style="[onlineserviceStyle]"
      v-if="isSupportIM"
      @click="goIM()"
    >
      <img
        style="width: 100%;"
        src="../../static/ic_online_service.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import http from '../../api/http'
import NavItem from './NavItem'
import CourseVideoDetail from './CourseVideoDetail'
import PayBanner from './PayBanner'
import CommentDetail from '@/views/comment/CommentDetail'
import { mapActions, mapState } from 'vuex'
import dayjs from 'dayjs'
import Player from '@/views/video/Player'
import util from '@/util/util'
import comm from '@/comm'
import {
  requestappInfo,
  getStatusHeight,
  getAppInfo,
  isAndroid,
  state
} from '@/api/appInfo'
import { checkPermission } from '@/api/permission'
import Comment from '@/views/comment/Comment'
import VideoMask from '@/views/video/VideoMask'
import { Sticky } from 'vant'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'

import api from '../../api/api'
import isBetween from 'dayjs/plugin/isBetween'
import animationData from '../../lottie/voice-bar.json'
import lottie from 'vue-lottie'
dayjs.extend(isBetween)

export default {
  name: 'Video',
  components: {
    VideoMask,
    Player,
    PayBanner,
    Comment,
    CourseVideoDetail,
    NavItem,
    CommentDetail,
    lottie,
    [Sticky.name]: Sticky,
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      isAvailable: false,
      anim: {},
      isPlaying: true,
      defaultOptions: { animationData: animationData, autoplay: false },
      productId: '',
      videoInstance: {},
      isShowCover: true,
      currComment: {},
      currentIndex: 0,
      isShowAll: false,
      isMaskShow: false,
      navItems: [
        {
          name: '详情',
          isSelect: true
        },
        {
          name: '评论',
          isSelect: false
        }
      ],
      swiperOption: {
        autoplay: false,
        autoHeight: true,
        observer: true,
        observeParents: true
      },
      isGoldMember: false,
      isShowTrySee: false,
      trySeeTime: 0,
      goodsInfo: '',
      couponList: [],
      couponNo: 0,
      currentItem: ''
    }
  },

  computed: {
    ...mapState('video', ['resp', 'currentVideo']),
    navOffest() {
      return util.getVideoHeight()
    },
    commentsInfo() {
      return this.resp.detail ? this.resp.detail.commentsInfo : null
    },

    showCommentDetail() {
      return Object.keys(this.currComment).length > 0
    },

    getTodayTip() {
      return this.resp.detail ? this.resp.detail.toDayCourse : null
    },

    videoHeightStyle() {
      console.log(util.getVideoHeight(), 'videoheight---')
      return {
        height: util.getVideoHeight() + 'px'
      }
    },

    commentStyle() {
      const top = util.getVideoHeight() + 'px'
      const statusHeight = getStatusHeight()
      const commentHeight =
        window.screen.height - util.getVideoHeight() - statusHeight + 'px'
      return {
        top: top,
        height: commentHeight
      }
    },
    isMaskShowFix() {
      return this.isMaskShow && !isAndroid()
    },

    isSupportIM() {
      if (!state.appInfoResp.appVersion) return false
      return (
        util.compareMv('3.2.0', state.appInfoResp.appVersion, true) &&
        this.resp?.detail?.isShowIM
      )
    },

    onlineserviceStyle() {
      return {
        top:
          (isNaN(getStatusHeight()) ? 0 : getStatusHeight()) +
          25 +
          util.getVideoHeight() +
          'px'
      }
    },
    swiper() {
      return this.$refs.mySwiper.$swiper
    },
    isSuppotUnlock() {
      return util.compareMv('3.8.0', state.appInfoResp.appVersion, true)
    }
  },

  watch: {
    showCommentDetail(val) {
      this.bodyElm = this.bodyElm || document.body
      val
        ? (this.bodyElm.style.overflow = 'hidden')
        : (this.bodyElm.style.overflow = 'auto')
    },
    resp(val) {
      this.productId = val.detail.detail.productId
      this.isAvailable = val.detail.detail.courses.isAvailable
      this.$set(
        this.navItems[1],
        'title',
        val.detail.commentsInfo.commentsCount
      )
      checkPermission(this.productId, () => {
        this.playCourseVideo(val.detail.courses.page.list[0])
        let hasPermission = this.isAvailable
        if (hasPermission) {
          this.currentIndex = 0
          this.navItems[1].isSelect = false
          this.navItems[0].isSelect = true
        }
      })
      this.tryShowShare()
    }
  },
  created() {
    this.getUserInfo()
    this.getMemberPermission()
    this.getCouponData()
  },
  mounted() {
    const param = {
      setId: comm.getQueryString('setId')
    }
    this.requestDetail(param).then(() => {
      this.isAvailable = this.resp?.detail.courses.isAvailable
    })
    requestappInfo()
    window.onResume = () => {
      requestappInfo()
      let hasPermission = this.isAvailable
      let _this = this
      if (!hasPermission) {
        setTimeout(
          () =>
            checkPermission(this.productId, function() {
              _this.requestDetail(param)
            }),
          5000
        )
      }
    }

    window.onscroll = this.updateMaskPosition
    let lastOrientationChangeTime
    window.addEventListener(
      'onorientationchange' in window ? 'orientationchange' : 'resize',
      () => {
        setTimeout(() => {
          this.updateMaskPosition()
        }, 500)
        lastOrientationChangeTime = new Date().getTime()
      },
      false
    )
    const innerH = window.innerHeight
    window.addEventListener('resize', () => {
      setTimeout(() => {
        if (new Date().getTime() - lastOrientationChangeTime < 300) return
        if (window.orientation === 180 || window.orientation === 0) {
          window.scrollBy(0, window.innerHeight < innerH ? 300 : -300)
        }
      }, 100)
    })
  },
  methods: {
    ...mapActions('video', ['requestDetail', 'requestVideo']),
    ...mapActions('appInfo', ['requestappInfo']),

    dayjs,
    controlVideo() {
      if (this.isPlaying) {
        // 当前正在播放，需要暂停
        this.videoInstance.pause()
        this.isPlaying = false
      } else {
        // 当前已暂停，需要播放
        this.videoInstance.play()
        this.isPlaying = true
      }
    },
    handleAnimation(anim) {
      this.anim = anim
    },
    onItemClick(index) {
      this.currentIndex = index
      this.swiper.slideTo(index)
    },
    updateSwiper() {
      this.swiper.update()
    },
    slideChange() {
      this.currentIndex = this.swiper.activeIndex
      this.navItems[this.currentIndex].isSelect = true
      this.navItems[this.currentIndex ^ 1].isSelect = false
    },

    onReplyEvent(item) {
      this.currComment = item
    },
    onShowAllEvent(val) {
      this.isShowAll = val
    },
    onCloseEvent() {
      this.currComment = ''
    },

    playCourseVideo(course) {
      if (getAppInfo().networkState !== 1) {
        this.$toast('正在消耗流量')
      }
      if (course.isHightlight) {
        this.$toast('订阅一财知道，收听专栏全部内容')
        return
        // this.isShowTrySee = true
        // this.trySeeTime = this.formatDuration(course.hightlightDuration)
      } else {
        this.isShowTrySee = false
        if (window.goods) {
          window.goods.showVideoMask(!course.isHightlight)
        }

        this.isShowCover = false
        this.requestVideo({
          videoIdentity: course.isAvailable
            ? course.videoIdentity
            : course.hightlightVideoIdentity
        })
        this.currentItem = course
        setTimeout(() => {
          this.setupVideoEventListeners()
          this.anim.play()
        }, 500)
      }
    },
    setupVideoEventListeners() {
      this.videoInstance = this.$refs.videoBox.getInternalVideoInstance()

      if (this.videoInstance && this.videoInstance.instance) {
        // 监听暂停事件
        this.videoInstance.instance.on('pause', () => {
          this.anim.stop()
          this.isPlaying = false
        })

        // 监听播放事件
        this.videoInstance.instance.on('play', () => {
          this.anim.play()
          this.isPlaying = true
        })
        this.videoInstance.instance.on('ended', () => {
          this.anim.stop()
          this.isPlaying = false
        })
      }
    },

    onStartPlay() {
      this.isMaskShow = true
      this.updateMaskPosition()
    },

    updateMaskPosition() {
      let mask = document.querySelector('video')
      let rect = mask.getBoundingClientRect()
      if (window.goods) {
        if (window.orientation === 180 || window.orientation === 0) {
          let devicePixelRatio = window.devicePixelRatio

          window.goods.updateVideoMask(
            this.isMaskShow,
            rect.x * devicePixelRatio,
            rect.y * devicePixelRatio,
            rect.width * devicePixelRatio,
            rect.height * devicePixelRatio
          )
        } else if (window.orientation === 90 || window.orientation === -90) {
          //横屏交给native全屏
          window.goods.updateVideoMask(this.isMaskShow, 0, 0, 0, 0)
        }
      }
    },

    tryShowShare() {
      if (getAppInfo().appVersion >= '3.1.0') {
        http
          .post('Course/api/GetShare', { setId: this.resp.detail.detail.setId })
          .then(response => {
            window.goods.showShare(
              JSON.stringify({
                isShow: true,
                title: response.detail.title,
                content: response.detail.content,
                url: response.detail.url
              })
            )
          })
      }
    },

    goIM() {
      util.go('ycstock://onlineservice?code=course')
    },
    formatDuration(duration) {
      const formatted = dayjs(duration * 1000).utc()
      const h = formatted.hour()
      const m = formatted.minute()
      const s = formatted.second()

      let result = ''
      if (h > 0) result += `${h}小时`
      if (m > 0) result += `${m}分钟`
      if (s > 0) result += `${s}秒`

      return result || '0秒' // 如果 duration = 0，返回 '0秒'
    },
    async getUserInfo() {
      const { detail, result } = await api.member.getUserInfo()
      if (result.code === 0) {
        if (detail.memberInfo && detail.memberInfo.level === 2) {
          this.isGoldMember = true
        }
      }
    },
    async getMemberPermission() {
      const { detail, result } = await api.member.getMemberPermission()
      if (result.code === 0) {
        console.info('detail.goodsInfo', detail.goodsInfo)
        this.goodsInfo = detail.goodsInfo
      }
    },
    async getCouponData() {
      const { detail, result } = await api.coupon.getCouponApi({
        kind: 1, // 解锁劵
        direction: 2,
        productType: 2, //  2课程
        statusList: [0] // 未使用
      })
      if (result.code === 0) {
        console.info('detail', detail)
        this.couponNo = detail.list.length

        this.couponList = detail.list.map(ite => {
          const currentDate = dayjs()
          ite.btnActive = dayjs(currentDate).isBetween(
            ite.validFrom,
            ite.validEnd
          )
          return ite
        })
      }
    },
    async creteUnlockOrder() {
      const couponNo = this.couponList[0].couponNo
      const { detail, result } = await api.course.creteCouponOrder({
        productId: this.resp.detail.detail.productId,
        subProductId: this.currentItem.courseId,
        couponNo: couponNo
      })
      if (result.code === 0) {
        console.info('detail', detail)
        const orderId = detail
        this.getExchangeResult(orderId)
        setTimeout(() => {
          if (!this.currentItem.isAvailable) {
            this.getExchangeResult(orderId)
          }
        }, 1000)
      }
    },
    async getExchangeResult(orderId) {
      console.info('orderId', orderId)
      const { detail, result } = await api.course.getExchangeResult({
        orderId: orderId
      })
      if (result.code === 0 && detail.success) {
        console.info('detail', detail)
        this.$set(this.currentItem, 'isAvailable', true)
        this.$set(this.currentItem, 'isHightlight', false)
        this.isShowTrySee = false
        this.requestVideo({
          videoIdentity: this.currentItem.isAvailable
            ? this.currentItem.videoIdentity
            : this.currentItem.hightlightVideoIdentity
        })
      }
    }
  }
}
</script>
<style lang="scss">
.black-color {
  color: #000;
}
.grey-color {
  color: #808080;
}
.special-video {
  .prism-player {
    background: #deecf7 !important;
  }
  .prism-player .prism-controlbar {
    z-index: 99999 !important;
    display: block !important;
  }
}
</style>

<style lang="scss" scoped>
.anim-box {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 999;
  padding-top: 76px;
  background: #deecf7;
  width: 100%;
  .static-ico {
    position: absolute;
    top: 45%;
    left: 0;
    right: 0;
    margin: 0 auto;
    z-index: 1;
  }
}
.warp {
  position: relative;
}

.page {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  padding-bottom: 190px;
}
.video {
  position: fixed;
  top: 0;
  z-index: 999;
  width: 100%;
}

.page-container {
  position: relative;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 160px;
}

.title {
  margin-top: 40px;
  margin-bottom: 30px;
  margin-left: 30px;
}

.marginL30 {
  margin-left: 30px;
}

.my-title {
  padding-bottom: 40px;
}

.jrgxTitle {
  margin-top: 40px;
}

.videoToday {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  margin: 26px 30px 39px;
  line-height: 106px;
  height: 106px;
  padding-left: 49px;
  background: #f3f3f3;
  position: relative;
  align-items: center;
}

.videoToday img {
  height: 52px;
  width: 52px;
  margin-right: 39px;
}

.sep20 {
  height: 20px;
  width: 100%;
}

.comment-container {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
}

.cover {
  top: 0;
  position: fixed;
  z-index: 999;
  width: 100%;
  -webkit-overflow-scrolling: touch;
}

.btnPlay {
  width: 100px;
  height: 100px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50px, -50px);
}

.imgDefault {
  display: inline-block;
  background-color: #fff;
  background-image: url('../../static/img_load_default_l.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position-x: 50%;
}

.onlineservice {
  position: fixed;
  right: 30px;
  width: 100px;
  height: 100px;
}
.my-swiper {
  z-index: 0;
}
</style>
